import React from "react";
import { useForm, Controller } from "react-hook-form";

// libs
import { Box, Grid, TextField, Stack, Button } from "@mui/material";

// services
import { removeStock } from "../../../services/StockService";

const RemoveStocks = ({
  productData,
  setOpenDrawer,
  getStockList,
  setOpenSnack,
  setSnackVariant,
  setErrMsg,
}) => {
  const {
    control,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    defaultValues: {
      quantity: "",
      remarks: "",
    },
  });

  // submit form remove stock
  async function onSubmit(data) {
    let formData = {};
    formData = data;
    formData.product_id = productData.id;
    formData.created_by = localStorage.getItem("user_id");
    formData.available_stocks = productData?.summary?.available_stock;

    if (formData) {
      try {
        const data = await removeStock(formData);
        if (data.data.success == 1) {
          setSnackVariant("success");
          setErrMsg(data.data.message);
          getStockList();
          setOpenDrawer(false);
          setOpenSnack(true);
        } else {
          const msg = data.data.errors;
          const updatedErrors = { ...errors };
          for (const key in msg) {
            if (msg.hasOwnProperty(key)) {
              const value = msg[key].join(" ");
              let field = key;
              updatedErrors[key] = { type: "manual", message: value };
              setError(field, {
                type: "server",
                message: value,
              });
            }
          }
        }
      } catch (error) {
      } finally {
      }
    }
  }

  return (
    <Box
      sx={{ flexGrow: 1, width: "408px" }}
      component="form"
      noValidate
      onSubmit={handleSubmit(onSubmit)}
    >
      <Grid container spacing={2} sx={{ padding: 5 }}>
        <Grid item xs={12} sx={{ padding: 4 }}>
          <TextField
            margin="normal"
            fullWidth
            label="Date"
            variant="filled"
            inputProps={{ autoComplete: "none" }}
            disabled={true}
            value={new Date().toLocaleDateString("en-US")}
          />

          <TextField
            margin="normal"
            fullWidth
            label="Product SKU"
            variant="filled"
            inputProps={{ autoComplete: "none" }}
            disabled={true}
            value={productData?.product_sku || ""}
          />

          <TextField
            margin="normal"
            fullWidth
            label="Product Name"
            variant="filled"
            inputProps={{ autoComplete: "none" }}
            disabled={true}
            value={productData?.product_name}
          />

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Controller
                name="quantity"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    margin="normal"
                    fullWidth
                    label="Qty"
                    variant="filled"
                    inputProps={{ autoComplete: "none" }}
                    type="number"
                    InputProps={{
                      inputProps: { min: 0 },
                    }}
                    onKeyPress={(event) => {
                      if (
                        event?.key === "-" ||
                        event?.key === "+" ||
                        event?.key === "e" ||
                        event?.key === "E" ||
                        event?.key === "."
                      ) {
                        event.preventDefault();
                      }
                    }}
                    error={!!errors.quantity}
                    helperText={
                      errors.quantity?.message
                        ? errors.quantity?.message
                        : errors.quantity
                        ? "Quantity is required."
                        : ""
                    }
                    {...field}
                  />
                )}
              />
            </Grid>
            {/* <Grid item xs={6}>
              <TextField
                margin='normal'
                fullWidth
                label='Units'
                variant='filled'
                inputProps={{ autoComplete: 'none' }}
                disabled={true}
                value={productData?.uom_units}
              />
            </Grid> */}
          </Grid>

          <Controller
            name="remarks"
            control={control}
            render={({ field }) => (
              <TextField
                margin="normal"
                fullWidth
                label="Remarks"
                variant="filled"
                inputProps={{ autoComplete: "none" }}
                error={!!errors.remarks}
                helperText={errors.remarks && "Remarks is required."}
                {...field}
              />
            )}
          />
          <Stack
            spacing={2}
            direction="row"
            display="flex"
            justifyContent="flex-end"
            alignItems="flex-end"
            mt={5}
          >
            <Button onClick={() => setOpenDrawer(false)} variant="outlined">
              Cancel
            </Button>
            <Button type="submit" variant="contained" color="success">
              Remove Stock
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RemoveStocks;
